import MuiLoadingButton, { LoadingButtonProps } from "@mui/lab/LoadingButton";

const LoadingButton: React.FC<LoadingButtonProps> = MuiLoadingButton;

export default LoadingButton;
export type { LoadingButtonProps };
